import React from 'react';
import Icon from './Icon';

/**
 * F10.2 — small "on your network" badge.
 *
 * Pure presentational. The decision of whether a peer is on the same LAN
 * lives in `useSameLAN(userId)` (Wave 2A). This component only renders the
 * pill when the parent has already determined the answer is yes.
 *
 * Reuses the `.t-chip.lan` class from F13.1's TransportChip stylesheet — so
 * the visual treatment stays in lock-step with the LAN colorway across all
 * surfaces.
 */
const SameLANBadge = () => (
  <span
    className="t-chip lan"
    style={{ height: 18, padding: '0 7px', fontSize: 10 }}
    aria-label="On your network"
  >
    <Icon name="wifi" size={10} stroke="#b6ffd6" /> on your network
  </span>
);

export default SameLANBadge;
